import React from 'react'

const ContentRowSpace=props=>{
    return (
        <div className="col-sm">
            <div style={{paddingTop: '8px',paddingBottom: '8px'}}></div>
        </div>
    )
}

export default ContentRowSpace


// WEBPACK FOOTER //
// ./src/views/ProjectGorgon/common/ContentRowSpace.js